import React from 'react'
import PropTypes from 'prop-types'
import Colors from "./Colors";

class CommissionedIndexPagePhoto extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hover: false
        };

        this.onHover = this.onHover.bind(this);
        this.onHoverOff = this.onHoverOff.bind(this);
    }
    onHover(){
        this.setState({ hover: true });
    }

    onHoverOff(){
        this.setState({ hover: false });
    }
    render() {
        return (
                <div className={this.props.isNarrow ? "column is-narrow" : "column"}>
                    <figure className="image wow fadeInUp fast"
                            style={{borderColor: Colors[this.props.color]}}
                            onMouseEnter={this.onHover}
                            onMouseLeave={this.onHoverOff}
                            title={this.props.caption}>
                        <a href={this.props.link}>
                            <img style={{display: this.state.hover ? 'none' : 'block'}}
                                 src={this.props.mainImageUrl}
                                 title={this.props.caption}/>
                        </a>
                        <a href={this.props.link}>
                            <img style={{display: this.state.hover ? 'block' : 'none'}}
                                 src={this.props.hoverImageUrl}
                                 title={this.props.caption}/>
                        </a>
                    </figure>
                </div>
        );
    }
}
CommissionedIndexPagePhoto.propTypes = {
    mainImageUrl: PropTypes.string,
    hoverImageUrl: PropTypes.string,
    caption: PropTypes.string,
    color: PropTypes.string,
    isNarrow: PropTypes.bool,
    link: PropTypes.string
};

export default CommissionedIndexPagePhoto



// WEBPACK FOOTER //
// ./src/components/CommissionedIndexPagePhoto.js